import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from '../../../../../src/app/core/models/generic-models';
import { IRejectBankProofRequest, IRejectBankProofResponse } from '../models/bank-proof.model';
import { rejectBankProofFailure, rejectBankProofRequest, rejectBankProofResponse } from '../actions/bank-proofs.actions';

export const rejectBankProofFeatureKey = 'rejectBankProof';

export interface RejectBankProofState {
  rejectBankProofRequest: IRejectBankProofRequest;
  rejectBankProofSuccess: IRejectBankProofResponse;
  rejectBankProofFailure: IGenericError<ErrorResponse>;
}

export const initialState: RejectBankProofState = {
  rejectBankProofRequest: undefined,
  rejectBankProofSuccess: undefined,
  rejectBankProofFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(rejectBankProofRequest, (state, action) => ({
    ...state,
    approveBankProofRequest: action.request
  })),
  on(rejectBankProofResponse, (state, action) => ({
    ...state,
    approveBankProofSuccess: action.response
  })),
  on(rejectBankProofFailure, (state, action) => ({
    ...state,
    approveBankProofFailure: action.error
  }))
);

export const getRejectBankProofRequest = (state: RejectBankProofState) => state.rejectBankProofRequest;
export const getRejectBankProofResponse = (state: RejectBankProofState) => state.rejectBankProofSuccess;
export const getRejectBankProofFailure = (state: RejectBankProofState) => state.rejectBankProofFailure;
